import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import CategoriesInput from "../components/CategoriesInput";
import CopyOnHover from "../components/CopyOnHover";

export default function SuppliersPage() {

    const [suppliers, setSuppliers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [accounts,setAccounts] = useState([
        {name:"",ipn:"",iban:""}
    ])
    const [showHistory,setShowHistory] = useState(false);
    const [history,setHistory] = useState([]);
    const [selectedSupplier,setSelectedSupplier] = useState(null);

    const [form, setForm] = useState({
        name: "",
        contactPerson: "",
        phone: "",
        telegram: "",
        currency: "USD",
        note: ""
    });

    const CATEGORY_LABELS = {
        FABRIC: "Тканини",
        HARDWARE: "Фурнітура",
        THREAD: "Нитки",
        FILLING: "Наповнювач",
        SUPPORT: "Підкладка",
        PACKAGING: "Пакування",
        PRINTS_EMBROIDERY: "Накати та вишивка",
    };

    const CATEGORY_COLORS = {
        FABRIC: "#d0ebff",
        HARDWARE: "#ffe066",
        THREAD: "#ffd6a5",
        FILLING: "#caffbf",
        SUPPORT: "#e5dbff",
        PACKAGING: "#ffc9c9",
        PRINTS_EMBROIDERY: "#b8f2e6",
    };

    useEffect(() => {
        loadSuppliers();
    }, []);

    const loadSuppliers = async () => {

        const res = await axios.get("/api/suppliers");

        setSuppliers(res.data);

    };

    const loadHistory = async (supplier) => {

        const res = await axios.get(`/api/suppliers/${supplier._id}/history`);

        setHistory(res.data);

        setSelectedSupplier(supplier);

        setShowHistory(true);

    };

    const addAccount = () => {
        setAccounts([...accounts,{name:"",ipn:"",iban:""}])
    }

    const updateAccount = (index,field,value) => {

        const copy = [...accounts]

        copy[index][field] = value

        setAccounts(copy)

    }

    const openCreate = () => {

        setEditing(null);

        setForm({
            name: "",
            contactPerson: "",
            phone: "",
            telegram: "",
            currency: "USD",
            note: ""
        });

        setShowModal(true);

    };

    const openEdit = (supplier) => {

        setEditing(supplier);

        setForm(supplier);

        setAccounts(
            supplier.accounts?.length
                ? supplier.accounts
                : [{name:"",ipn:"",iban:""}]
        );

        setShowModal(true);

    };

    const saveSupplier = async () => {

        const payload = {
            ...form,
            categories: form.categories || [],
            accounts
        };

        if (editing) {

            await axios.put(`/api/suppliers/${editing._id}`, payload);

        } else {

            await axios.post("/api/suppliers", payload);

        }

        setShowModal(false);

        loadSuppliers();

    };

    const deleteSupplier = async (id) => {
        if (!window.confirm("Видалити постачальника?")) return;

        try {
            await axios.delete(`/api/suppliers/${id}`);
            loadSuppliers();
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.message || "Помилка при видаленні постачальника");
        }
    };

    return (

        <div className="production-tab-panel tab-content">

            <div className="d-flex justify-content-between mb-3">

                <h3>Постачальники</h3>

                <Button onClick={openCreate}>
                    Додати постачальника
                </Button>

            </div>

            <div className="materials-hub-table-scroll">
                <Table
                    bordered
                    hover
                    className="materials-hub-table suppliers-categories-col align-middle mb-0"
                >
                <thead className="table-dark text-center">
                <tr>
                    <th rowSpan={2}>Назва</th>
                    <th rowSpan={2}>Контакт</th>
                    <th rowSpan={2}>Телефон</th>
                    <th rowSpan={2}>Валюта</th>
                    <th rowSpan={2}>Категорії</th>

                    <th colSpan={3}>Реквізити</th>

                    <th rowSpan={2} className="text-nowrap">
                        Дії
                    </th>
                </tr>

                <tr>
                    <th>ПІБ</th>
                    <th>ІПН</th>
                    <th>IBAN</th>
                </tr>

                </thead>

                <tbody>

                {suppliers.map(s => (

                    <tr key={s._id}>

                        <td
                            style={{cursor:"pointer",fontWeight:500}}
                            onClick={()=>loadHistory(s)}
                        >
                            {s.name}
                        </td>

                        <td>{s.contactPerson}</td>

                        <td>{s.phone}</td>

                        <td>{s.currency}</td>
                        <td>
                            <div className="d-flex flex-wrap gap-1">
                                {s.categories?.length ? (
                                    s.categories.map((cat, i) => (
                                        <span
                                            key={i}
                                            style={{
                                                padding: "2px 6px",
                                                borderRadius: "6px",
                                                backgroundColor: CATEGORY_COLORS[cat] || "#e9ecef",
                                                fontSize: "12px"
                                            }}
                                        >
                                          {CATEGORY_LABELS[cat] || cat}
                                        </span>
                                    ))
                                ) : (
                                    <span style={{ color: "#999", fontSize: "12px" }}>
                                        —
                                      </span>
                                )}
                            </div>
                        </td>
                        <td>
                            {s.accounts?.map((acc, i) => (
                                <div key={i} className="mb-2">
                                    <CopyOnHover text={acc.name} buttonPosition="center" />
                                </div>
                            ))}
                        </td>

                        <td>
                            {s.accounts?.map((acc, i) => (
                                <div key={i} className="mb-2">
                                    <CopyOnHover text={acc.ipn} buttonPosition="center" />
                                </div>
                            ))}
                        </td>

                        <td>
                            {s.accounts?.map((acc, i) => (
                                <div key={i} className="mb-2">
                                    <CopyOnHover
                                        text={acc.iban}
                                        copyValue={acc.iban?.replace(/\s+/g, "")}
                                        buttonPosition="center"
                                    />
                                </div>
                            ))}
                        </td>

                        <td className="text-center">
                            <div className="d-inline-flex gap-1 justify-content-center align-items-center flex-nowrap">
                                <Button
                                    variant="link"
                                    className="p-0 border-0 shadow-none text-decoration-none lh-1"
                                    style={{ fontSize: "1rem", minWidth: 0, color: "#fd7e14" }}
                                    onClick={() => openEdit(s)}
                                    aria-label="Редагувати"
                                >
                                    ✏️
                                </Button>
                                <Button
                                    variant="link"
                                    className="p-0 border-0 shadow-none text-decoration-none lh-1"
                                    style={{ fontSize: "1rem", minWidth: 0, color: "#dc3545" }}
                                    onClick={() => deleteSupplier(s._id)}
                                    aria-label="Видалити"
                                >
                                    🗑
                                </Button>
                            </div>
                        </td>

                    </tr>

                ))}

                </tbody>

                </Table>
            </div>

            {/* Modal */}

            <Modal show={showModal} onHide={() => setShowModal(false)}>

                <Modal.Header closeButton>

                    <Modal.Title>

                        {editing ? "Редагувати постачальника" : "Новий постачальник"}

                    </Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <Form>

                        <Form.Group className="mb-3">

                            <Form.Label>Назва</Form.Label>

                            <Form.Control
                                value={form.name}
                                onChange={(e)=>setForm({...form,name:e.target.value})}
                            />

                        </Form.Group>

                        <Form.Group className="mb-3">

                            <Form.Label>Контактна особа</Form.Label>

                            <Form.Control
                                value={form.contactPerson || ""}
                                onChange={(e)=>setForm({...form,contactPerson:e.target.value})}
                            />

                        </Form.Group>

                        <Form.Group className="mb-3">

                            <Form.Label>Телефон</Form.Label>

                            <Form.Control
                                value={form.phone || ""}
                                onChange={(e)=>setForm({...form,phone:e.target.value})}
                            />

                        </Form.Group>

                        <Form.Group className="mb-3">

                            <Form.Label>Валюта</Form.Label>

                            <Form.Select
                                value={form.currency}
                                onChange={(e)=>setForm({...form,currency:e.target.value})}
                            >
                                <option value="USD">USD</option>
                                <option value="UAH">UAH</option>
                            </Form.Select>

                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Категорії</Form.Label>

                            <CategoriesInput
                                value={form.categories || []}
                                onChange={(categories) =>
                                    setForm({ ...form, categories })
                                }
                            />
                        </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Реквізити</Form.Label>
                        {accounts.map((acc,i)=>(
                            <div key={i} className="border p-2 mb-2">

                                <Form.Control
                                    placeholder="ПІБ"
                                    value={acc.name}
                                    onChange={(e)=>updateAccount(i,"name",e.target.value)}
                                />

                                <Form.Control
                                    className="mt-2"
                                    placeholder="ІПН"
                                    value={acc.ipn}
                                    onChange={(e)=>updateAccount(i,"ipn",e.target.value)}
                                />

                                <Form.Control
                                    className="mt-2"
                                    placeholder="IBAN"
                                    value={acc.iban}
                                    onChange={(e)=>updateAccount(i,"iban",e.target.value)}
                                />

                            </div>
                        ))}
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={addAccount}
                        >
                            + Додати реквізити
                        </Button>
                    </Form.Group>
                        <Form.Group>

                            <Form.Label>Коментар</Form.Label>

                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={form.note || ""}
                                onChange={(e)=>setForm({...form,note:e.target.value})}
                            />

                        </Form.Group>
                    </Form>

                </Modal.Body>

                <Modal.Footer>

                    <Button onClick={saveSupplier}>
                        Зберегти
                    </Button>

                </Modal.Footer>

            </Modal>
            <Modal
                show={showHistory}
                onHide={()=>setShowHistory(false)}
                size="lg"
            >

                <Modal.Header closeButton>

                    <Modal.Title>

                        Історія закупок — {selectedSupplier?.name}

                    </Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <Table bordered>

                        <thead>

                        <tr>

                            <th>Дата</th>
                            <th>Матеріал</th>
                            <th>Кількість</th>
                            <th>$</th>
                            <th>грн</th>

                        </tr>

                        </thead>

                        <tbody>

                        {history.map((h,i)=>(

                            <tr key={i}>

                                <td>
                                    {new Date(h.purchaseId?.date).toLocaleDateString()}
                                </td>

                                <td>
                                    {h.materialId?.name}
                                </td>

                                <td>
                                    {h.qty}
                                </td>

                                <td>
                                    {h.priceUSD?.toFixed(2)}
                                </td>

                                <td>
                                    {h.priceUAH?.toFixed(0)}
                                </td>

                            </tr>

                        ))}

                        </tbody>

                    </Table>

                </Modal.Body>

            </Modal>

        </div>

    );
}